import { Base, Component } from '@/vue-property-decorator'
import CompanyInfo from '../../companyInfo'
import CopyShare from '../../copyRight'
import LinkList, { sortMap } from '../../linkList'
// import LogoArea from '../../../logoArea'
import { CommonSwitchStatus } from '@/api/common/type'
import { RouteName } from '@/router/config'
import { useAboutUsStore } from '@/views/center/about-us/store'
import { useFooterStore } from '@/layouts/components/footer/store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import LogoArea from '../../logoArea'
import OfficialChannel from '../../officialChannel'
import PhotographImg from '../../photographImgBox'
import style from './style.module.scss'

// theme1对应美术欧美版
@Component<FooterLayout4>({ name: 'FooterLayout4' })
export default class FooterLayout4 extends Base {
  footerInfos = useFooterStore()
  get hasAboutUs() {
    const { brandLogoInfos } = useMainStore()
    const { aboutUsList } = useAboutUsStore()
    const { support, aboutUs } = this.footerInfos.footerInfos?.quickJump || {}
    return (
      (support?.child?.includes('aboutUsSub') ||
        aboutUs?.child?.includes('aboutUsSub')) &&
      brandLogoInfos?.aboutUsStatus == CommonSwitchStatus.OPEN &&
      aboutUsList.length > 0 &&
      !this.footerInfos?.footerInfos?.quickJumpStatus
    )
  }
  private aboutUsCom() {
    const { t } = useI18n()
    const { aboutUsList } = useAboutUsStore()
    return (
      <div class={style.aboutUsBox}>
        <div class={style.title}>{t('lobby.footer.quickJump.aboutUsSub')}</div>
        {aboutUsList.map((item) => {
          return (
            <div
              class={{
                [style.item]: true,
                'about-us-item': true
              }}
              onClick={() => {
                this.$router.push({
                  name: RouteName.ABOUT_US,
                  query: {
                    current: String(item.id)
                  }
                })
              }}
            >
              {item.title?.slice(0, 9)}
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const filterArr1 = [sortMap.RecreationCity, sortMap.Game, sortMap.Support]
    return (
      <div class={style.layout4BoxH5}>
        {/* <FastShare showTitle={true} long={54} /> */}

        <LinkList layoutType={'vertical'} filterArr={filterArr1} />
        <div class={style.linkAndShareBox}>
          {this.hasAboutUs && this.aboutUsCom()}
          {/* <FastShare showTitle={true} long={70} /> */}
          <OfficialChannel />
        </div>

        <CompanyInfo />
        <LogoArea />
        <PhotographImg />

        <CopyShare />
      </div>
    )
  }
}
